import createIcon from '../../createIcon';

/**
 * @component @name NorthWest
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDE0LjVINi41VjcuOTFMMTguMDkgMTkuNUwxOS41IDE4LjA5TDcuOTEgNi41SDE0LjVWNC41SDQuNVYxNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NorthWest = createIcon('NorthWest', [
  [
    'path',
    { d: 'M4.5 14.5H6.5V7.91L18.09 19.5L19.5 18.09L7.91 6.5H14.5V4.5H4.5V14.5Z', key: 'e3hzo0' },
  ],
]);

export default NorthWest;
